var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_10887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.166 2.50065H15.4993C15.7204 2.50065 15.9323 2.58845 16.0886 2.74473C16.2449 2.90101 16.3327 3.11297 16.3327 3.33398V16.6673C16.3327 16.8883 16.2449 17.1003 16.0886 17.2566C15.9323 17.4129 15.7204 17.5007 15.4993 17.5007H0.499349C0.278335 17.5007 0.0663736 17.4129 -0.0899067 17.2566C-0.246187 17.1003 -0.333984 16.8883 -0.333984 16.6673V3.33398C-0.333984 3.11297 -0.246187 2.90101 -0.0899067 2.74473C0.0663736 2.58845 0.278335 2.50065 0.499349 2.50065H3.83268V0.833984H5.49935V2.50065H10.4993V0.833984H12.166V2.50065ZM10.4993 4.16732H5.49935V5.83398H3.83268V4.16732H1.33268V7.50065H14.666V4.16732H12.166V5.83398H10.4993V4.16732ZM14.666 9.16732H1.33268V15.834H14.666V9.16732ZM2.99935 11.6673H4.66602V13.334H2.99935V11.6673ZM6.33268 11.6673H12.9993V13.334H6.33268V11.6673Z",
    fill: "#C2C2D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_10887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.d883b1434d602854d227d244072222ee.svg";
export { ForwardRef as ReactComponent };